
export default (function (Drupal, drupalSettings, once) {

  Drupal.behaviors.sidenavigation = {
    attach: function (context, settings) {
      const actionItems = document.querySelectorAll('.p2-action-item');
      let scrolled = false;

      const addScrolled = () => {
        actionItems.forEach(item => {
          item.classList.add("p2-action-item--scrolled");
        })
      }

      if (window.scrollY > 0) {
        addScrolled();
        scrolled = true;
      }

      document.addEventListener('scroll', () => {
        if (window.scrollY > 0 && !scrolled) {
          addScrolled();
          scrolled = true;
        }
      });


    },
  };
})(Drupal, drupalSettings, once);
